import React from "react";
import { useLanguage } from "../context/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      className="py-24 lg:py-32 bg-[#F3F4F1]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#5C6B5D]">
            {t.about.label}
          </span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] text-[#202C21] font-semibold">
            {t.about.title}
          </h2>
          <p className="mt-6 text-lg text-[#5C6B5D] leading-relaxed max-w-2xl">
            {t.about.text}
          </p>
          <div className="mt-8 flex items-center gap-4 text-sm text-[#5C6B5D]">
            <span className="w-12 h-px bg-[#75947A]" />
            <span className="uppercase tracking-[0.2em] text-xs font-bold">
              Ericeira · Portugal
            </span>
          </div>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative aspect-[4/5] rounded-[28px] overflow-hidden bg-[#E6EDE7] border border-[rgba(117,148,122,0.2)]">
            <img
              src="/images/ericeira-praia-dos-pescadores-2.webp"
              alt="Ericeira cliffside"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
